import clsx from "clsx";
import React, { ComponentProps, ElementType, ReactNode } from "react";

// Renaming `Component` to `ElementTypeProp` to avoid naming conflict
interface OverridableComponentProps<E extends ElementType> {
    as?: E;
}

interface TranslateOwnProps {
    if: boolean;
    children: ReactNode;
    className?: string;
}

type TranslateProps<E extends ElementType> = TranslateOwnProps & OverridableComponentProps<E> & ComponentProps<E>;

// Renaming `Component` to `ElementTypeProp` in the function parameter
export const Translate = <E extends ElementType = "span">({
    if: shouldTranslate,
    as: ElementTypeProperty = "span",
    children,
    className,
    ...rest
}: TranslateProps<E>) => {
    return (
        <ElementTypeProperty className={clsx({ "no-translate": !shouldTranslate }, className)} {...rest}>
            {children}
        </ElementTypeProperty>
    );
};
